(() => {
  const initialise = () => document.querySelectorAll('[data-nz-ranges]:not([data-enhanced])').forEach(root => {
    const nav = root.querySelector('.ki-nz-range-nav');
    const tabs = [...nav.querySelectorAll('a')];
    const panels = tabs.map(tab => root.querySelector(tab.hash));
    if (panels.some(panel => !panel)) return;
    const select = (index, focus = false) => {
      tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
        panels[i].hidden = i !== index;
      });
      if (focus) tabs[index].focus();
    };
    nav.setAttribute('role', 'tablist');
    tabs.forEach((tab, index) => {
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-controls', panels[index].id);
      panels[index].setAttribute('role', 'tabpanel');
      panels[index].setAttribute('aria-labelledby', tab.id);
      panels[index].tabIndex = 0;
      tab.addEventListener('click', event => {
        event.preventDefault();
        select(index);
        history.replaceState(null, '', tab.hash);
      });
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        select(next, true);
        history.replaceState(null, '', tabs[next].hash);
      });
    });
    const syncHash = () => {
      const index = tabs.findIndex(tab => tab.hash === location.hash);
      if (index < 0) return;
      select(index);
      root.scrollIntoView({block: 'start'});
    };
    root.dataset.enhanced = 'true';
    select(Math.max(0, tabs.findIndex(tab => tab.hash === location.hash)));
    window.addEventListener('hashchange', syncHash);
    if (tabs.some(tab => tab.hash === location.hash)) root.scrollIntoView({block:'start'});
  });
  initialise();
  document.addEventListener('shopify:section:load', initialise);
})();
